export default __webpack_public_path__ + "static/bsc-0918211c755e71e0e6cdd1a503042600.svg";